/**
 * Created by weid on 2017/9/5.
 */
import reducerGenerator from 'reducerGenerator';
import types from '../constants/types';

// 登录用户信息
const initialState = {};

const ACTION_HANDLERS = {
    [types.SET_USER_INFO](state, action) {
        return {
            ...state,
            ...action.userInfo
        };
    }
};

export default reducerGenerator(initialState, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/rootRedux/reducers/userInfo.js